import React, {useState} from "react";
import {AppComponent} from "../App";
import css from "../css/admin.module.css";
import {Button, Divider, Paper} from "@mui/material";
import {post} from "./post";

export const Settings = () => {
    const [json, setJSON] = useState(null);

    const vkOAuth = () => {
        AppComponent.SetLoading(true);

        const data = {
            client_id: "53687294",
            display: "page",
            redirect_uri: `https://oauth.vk.com/blank.html`,
            scope: "video",
            response_type: "code",
            v: "5.131"
        }
        const win = window.open(`https://oauth.vk.com/authorize?${new URLSearchParams(data)}`);
        const int = setInterval(() => {
            if (win.closed) {
                clearInterval(int);
                const urlWithCode = prompt("Insert URL With Code");

                if (urlWithCode) {
                    const url = "https://script.google.com/macros/s/AKfycbwOJ-PJ0fOV7ncBdj42l8jmjKCCE5DfxYqRgj0BXYnHLULCLkI_71wGPfADYmoSeeER/exec";
                    const {code} = Object.fromEntries(new URLSearchParams(new URL(urlWithCode).hash.slice(1)));
                    fetch(`${url}?method=vk&code=${code}`).then(res => res.json()).then(res => {
                        setJSON(res);
                        AppComponent.SetLoading(false);
                    })
                }
            }
        }, 500)
    }

    const updateDocs = async () => {
        setJSON(null);
        AppComponent.SetLoading(true);
        setJSON(await post("updateDocs"))
        AppComponent.SetLoading(false);
    }
    const getStat = async () => {
        setJSON(null);
        AppComponent.SetLoading(true);
        setJSON(await post("getStat"))
        AppComponent.SetLoading(false);
    }
    const updateSettings = async () => {
        AppComponent.SetLoading(true);
        setJSON(await post("updateSettings"))
        AppComponent.SetLoading(false);
    }
    const updateCampaigns = async () => {
        AppComponent.SetLoading(true);
        setJSON(await post("updateCampaigns"))
        AppComponent.SetLoading(false);
    }

    const injectParserData = async () => {
        AppComponent.SetLoading(true);

        const res = await fetch('http://localhost:3002/problems', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'}
        });

        const response = await res.json();
        const data = response.reduce((a, {id, HTMLBody, qid, hint, guid, params}) => ({...a, [id]: {HTMLBody, hint, qid, guid, params: JSON.stringify(params)}}), {});

        setJSON(await post("injectParserData", {data}))
        AppComponent.SetLoading(false);
    }
    const updateProblems = async () => {
        AppComponent.SetLoading(true);
        setJSON(await post("updateProblems"))
        AppComponent.SetLoading(false);
    }
    const setTelegramWebhook = async () => {
        AppComponent.SetLoading(true);
        setJSON(await post("setTelegramWebhook"))
        AppComponent.SetLoading(false);
    }

    return (
        <div className={css.settings}>
            <Paper elevation={3} className={css.admin}>
                <div className={css.body}>
                    <div className={css.buttons}>
                        <Button variant={"contained"} onClick={vkOAuth}>VK OAuth</Button>
                        <Button variant={"contained"} onClick={updateSettings}>Update Settings</Button>
                        <Button variant={"contained"} onClick={updateCampaigns}>Update Campaigns</Button>
                        <Button variant={"contained"} onClick={updateDocs}>Update Docs</Button>
                        <Button variant={"contained"} onClick={updateProblems}>Update Problems</Button>
                        <Divider/>
                        <Button variant={"contained"} onClick={getStat}>Get Stat</Button>
                        <Divider/>
                        <Button variant={"contained"} onClick={setTelegramWebhook}>Set Telegram Webhook</Button>
                        <Button variant={"contained"} onClick={injectParserData}>Inject Parser Data</Button>
                    </div>
                    <div className={css.json}>
                        <div className={css.preContainer}>
                            <pre>
                                {json && JSON.stringify(json, null, "  ")}
                            </pre>
                        </div>
                    </div>
                </div>
            </Paper>
        </div>
    )
}
